import {
  Box,
  SimpleGrid,
  Text,
  Flex,
  OrderedList,
  ListItem
} from "@chakra-ui/react";
import SectionHeading from "./sectionHeading";
import LineSection from "../lineSection";
import Lang from "../../Lang";

export default function HowCanHelp() {
  return (
    <Box
      color={"white"}
    >
      <LineSection />

      <SimpleGrid
        columns={{ base: 1, md: 1, xl: 2 }}
      >

        {/* left section */}
        <Box>
          <Flex
            justifyContent={"flex-end"}
            alignItems={"center"}
            w={"full"}
          >
            <Box>
              <Box
                w={{ base: "full", md: "md", xl: "lg" }}
                pr={{ base: 0, md: 0 }}
                pt={{ base: 7 }}
              >
                <SectionHeading
                  title="How we can help"
                />
              </Box>

              <Text
                w={{ base: "full", md: "full", xl: "xl" }}
                pt={{ base: 3, md: 4, xl: 10 }}
                pb={{ base: 3, md: 4, xl: 4 }}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
                fontWeight={"bold"}
              >
                <Lang text="We offer businesses a 46-hour consultancy package free of charge." />
              </Text>
              <Text
                w={{ base: "full", md: "full", xl: "xl" }}
                py={{ base: 3, md: 4, xl: 4 }}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
                fontWeight={"bold"}
              >
                <Lang text="During this process, we will work together to:" />
              </Text>
              <OrderedList
                w={{ base: "full", md: "full", xl: "xl" }}
                pt={{ base: 5, md: 10 }}
                pb={{ base: 20, md: 40 }}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              >
                <ListItem><Lang text="Identify and select a project with a high potential for success." /></ListItem>
                <ListItem><Lang text="Design the strategy for data selection and extraction." /></ListItem>
                <ListItem><Lang text="Explore the various solutions that AI can offer to address the specific challenges of your company." /></ListItem>
                <ListItem><Lang text="Present the results of our technical intervention." /></ListItem>
                <ListItem><Lang text="Develop a customized technological development plan." /></ListItem>
              </OrderedList>

            </Box>
            <Box
              w={"100px"}
            ></Box>
          </Flex>
        </Box>

        {/* right section */}
        <Box
          bgImage={"img/digital-representation-pie-chart-against-mature-students-with-teacher-laptop-library.webp"}
          backgroundSize={"cover"}
          backgroundPosition={"center"}
          display={{ base: "none", md: "none", xl: "inline" }}
        >
          <Box className="opacityTop"
            h={"50%"}
            w={"full"}
          >
            &nbsp;
          </Box>
          <Box className="opacityBottom"
            h={"50%"}
            w={"full"}
          >
            &nbsp;
          </Box>

        </Box>

      </SimpleGrid>

    </Box>
  );
}